import React from 'react';

import { Tab as MuiTab, Tabs as MuiTabs } from '@material-ui/core';
import { TabsProps as MuiTabProps } from '@material-ui/core/Tabs';
import weakKey from 'weak-key';

import { MenuSectionNavType } from '../../../types/menu.d';

export interface TabsNavProps extends MuiTabProps {
  handleTabClick?: (event: any) => void;
  tabs: MenuSectionNavType[];
}

export const TabsNav = (props: TabsNavProps): JSX.Element => {
  const { handleTabClick, tabs, ...rest } = props;

  if (!tabs) {
    return null;
  }

  return (
    <MuiTabs
      indicatorColor="primary"
      scrollButtons="off"
      value={false}
      variant="scrollable"
      {...rest}
    >
      {tabs.map((tab) => (
        <MuiTab
          aria-label={tab.label}
          data-id={tab.id}
          label={tab.label}
          key={weakKey({ tab })}
          onClick={() => handleTabClick(tab.id)}
        />
      ))}
    </MuiTabs>
  );
};
